/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { DataRest, InvitationsListData } from '../model/api/data-rest';
import { resources } from './api';


@Injectable({
    providedIn: 'root'
})
export class InvitationsService {

    constructor(
        private http: HttpClient
    ) { }

    getInvitationsList(pending?: boolean, type?: number):
        Observable<InvitationsListData> {
        let params = new HttpParams();
        if (pending !== undefined) {
            params = params.set('pending', pending);
        }
        if (type !== undefined) {
            params = params.set('type', type);
        }
        console.log(params);
        return this.http.get<InvitationsListData>(`${environment.apiUrl}${resources.get('invitations')}`, { params });
    }


    invitationsShareDevice(email: string, firstName: string, lastName: string, deviceId: number, remotesMax: number): Observable<DataRest> {
        const payload = {
            Email: email,
            FirstName: firstName,
            LastName: lastName,
            DeviceId: deviceId,
            RemotesMax: remotesMax
        };
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}`, payload);
    }

    invitationsAccept(token: string,): Observable<DataRest> {
        const payload = {};
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}/${token}${resources.get('accept')}`, payload);
    }

    invitationsReject(token: string,): Observable<DataRest> {
        const payload = {};
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}/${token}${resources.get('reject')}`, payload);
    }

    invitationsThGroupShare(email: string, firstName: string, lastName: string, groupId: number): Observable<DataRest> {
        const payload = {
            Email: email,
            FirstName: firstName,
            LastName: lastName,
            GroupId: groupId,
        };
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}`, payload);
    }
}
